<template>
  <input
    :type="type"
    :value="resolvedValue"
    :class="[
      'read-only:bg-conference-surface-muted read-only:text-conference-ink w-full rounded-[1px] border leading-none transition outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60',
      sizeClass,
      toneClass,
    ]"
    @input="handleInput"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const model = defineModel<string | null>();

const props = withDefaults(
  defineProps<{
    size?: 'sm' | 'md';
    tone?: 'chat' | 'dark' | 'light';
    type?: string;
    value?: string | null;
  }>(),
  {
    size: 'md',
    tone: 'light',
    type: 'text',
    value: undefined,
  },
);

const sizeClass = computed(() =>
  props.size === 'sm' ? 'h-5.25 px-1.5 conference-text-control' : 'h-6.25 px-2 conference-text-control',
);

const resolvedValue = computed(() => {
  const nextValue = model.value !== undefined ? model.value : props.value;
  return nextValue ?? '';
});

const toneClass = computed(() => {
  switch (props.tone) {
    case 'dark':
      return 'border-conference-ink bg-conference-structure text-white placeholder:text-slate-400 focus:border-conference-accent focus-visible:ring-conference-accent/25';
    case 'chat':
      return 'border-conference-dock-border bg-white text-conference-dock-text placeholder:text-slate-500 focus:border-conference-accent-deep focus-visible:ring-conference-accent/15';
    default:
      return 'border-conference-border bg-white text-slate-900 placeholder:text-slate-400 focus:border-conference-accent-deep focus-visible:ring-conference-accent/15';
  }
});

function handleInput(event: Event): void {
  const nextValue = (event.target as HTMLInputElement).value;
  model.value = nextValue === '' ? null : nextValue;
}
</script>
